import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import PetCardNew from "../PetCardNew/PetCardNew";
import React from "react";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";

interface IPetCardList{
  petsList: IPetItemResponse[];
  className?: string;
  handlePetSelection: (pet: IPetItemResponse) => void;
  isDashBoardPetCardBooking?: { wellnessIconCoordinates: { x: string; y: string },
   wellnessIcon: { width: number, height: number } } | undefined;
}

const PetCardListNew = ({
  petsList,
  className,
  handlePetSelection,
  isDashBoardPetCardBooking,
}: IPetCardList) => {
  const { selectedPets } = useAppointmentStore();

  return (
    <>
      {petsList?.map((pet) => (
        <div
          key={pet.id}
          className={`w-full cursor-pointer ${className}`}
          onClick={()=>{
            handlePetSelection(pet);
          }}>
          <PetCardNew
            image={pet.image}
            pet={pet}
            notBold={false}
            isActive={!!selectedPets?.find((p: IPetItemResponse) => p.id === pet.id)}
            petAvatarSize={35}
            isWellnessPlan={pet?.isWellnessplan}
            isDashBoardPetCardBooking={isDashBoardPetCardBooking ? isDashBoardPetCardBooking : undefined}
          />
        </div>
      ))}
    </>
  );
};

export default PetCardListNew;
